<script lang="ts" setup>
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { $fetch } = useFetch();

const { data } = useAsyncData(
  'home:information:column',
  () => $fetch('/popSpecialColumn/getColumnPage',
    { method: 'post', data: { pageNum: 1, pageSize: 6 } },
  ),
  {
    transform: (data) => data.records ?? [],
  },
);
</script>

<template>
  <div class="mt-56 rounded-52 bg-#f9fafb p-40" v-if="data">
    <div class="flex-y-center justify-between">
      <div class="relative h-520 w-712 overflow-hidden rounded-32 bg-white p-32" v-if="data[0]">
        <img src="@/home/assets/home/4/column1.png" class="absolute right-32 top-48 h-293 w-356 object-cover">
        <h3 class="line-clamp-2 mt-276 text-36 text-#0a0b5c font-medium leading-120%">{{ data[0].columnName.slice(0, 3) }}<br>{{ data[0].columnName.slice(3) }}</h3>
        <div class="mt-22 flex items-end justify-between">
          <p class="line-clamp-3 w-369 text-justify text-16 text-#263238 font-normal leading-normal">{{ data[0].columnDesc }}</p>
          <RouterLink :to="`/column/detail/${data[0].columnId}`" target="_blank" class="group block">
            <button class="h-50 w-220 border-1.5 border-#0a0b5c rounded-160 border-solid bg-white text-16 text-#0a0b5c font-normal">查看专栏</button>
          </RouterLink>
        </div>
      </div>
      <div class="h-520 w-368 overflow-hidden rounded-32 bg-#fff px-32 text-center" v-if="data[1]">
        <img src="@/home/assets/home/4/column2.png" class="mx-auto mt-37 h-223 w-212 object-cover">
        <h3 class="line-clamp-1 mt-16 text-center text-36 text-#0a0b5c font-medium leading-120%">{{ data[1].columnName }}</h3>
        <p class="line-clamp-2 mt-16 text-justify text-17 text-#263238 font-normal leading-normal">{{ data[1].columnDesc }}</p>
        <RouterLink :to="`/column/detail/${data[1].columnId}`" target="_blank" class="group block">
          <button class="mt-32 h-50 w-220 border-1.5 border-#0a0b5c rounded-160 border-solid bg-white text-16 text-#0a0b5c font-normal">查看专栏</button>
        </RouterLink>
      </div>
    </div>

    <div class="mt-40 flex justify-between">
      <div class="mt-18 w-500">
        <div class="ml-34">
          <img src="@/home/assets/home/4/hot.png" class="h-26 w-65 object-cover">
          <h2 class="mt-20 bg-[linear-gradient(90deg,#0103FF_0%,#01E4FF_60.62%)] bg-clip-text text-60 text-transparent font-bold leading-120%">热门专栏</h2>
          <h3 class="mt-6 mt-6 text-60 text-#0a0b5c font-medium leading-120%">Popular columns</h3>
          <p class="mt-12 text-justify text-16 text-#263238 font-normal leading-normal">开源法律社区特别打造“全球开源相关法律及政策”“开源许可证翻译”“重点报告翻译”“全球开源相关司法案例”专栏，通过追踪全球开源政策动态、自研新兴领域开源许可证、解读及翻译已有开源许可证、精选全球开源司法案例，构建全面的开源法律支持体系。</p>
        </div>
        <div class="relative mt-60 h-212 w-492 rounded-32 bg-white p-32" v-if="data[3]">
          <img src="@/home/assets/home/4/column3.png" class="absolute right-22 top--26 size-120 bg-cover">
          <h3 class="line-clamp-1 h-36 w-330 text-30 text-#0a0b5c font-medium leading-120%">{{ data[3].columnName }}</h3>
          <div class="mt-8 h-104 flex items-end justify-between">
            <p class="line-clamp-4 w-276 text-17 text-#263238 font-normal leading-normal">{{ data[3].columnDesc }}</p>
            <RouterLink :to="`/column/detail/${data[3].columnId}`" target="_blank" class="group block">
              <div class="flex-y-center text-16 text-#0a0b5c font-normal leading-120%">查看专栏 <div class="i-icons:arrow-right-1 ml-8 size-16"></div></div>
            </RouterLink>
          </div>
        </div>
      </div>

      <div class="w-588">
        <div class="h-221 rounded-32 bg-white p-32" v-if="data[2]">
          <h3 class="line-clamp-1 h-43 text-36 text-#0a0b5c font-medium leading-120%">{{ data[2].columnName }}</h3>
          <p class="line-clamp-2 mt-8 h-52 text-17 text-#263238 font-normal leading-normal">{{ data[2].columnDesc }}</p>
          <RouterLink :to="`/column/detail/${data[2].columnId}`" target="_blank" class="group block">
            <div class="mt-35 flex-y-center items-end justify-end text-16 text-#0a0b5c font-normal leading-120%">查看专栏 <div class="i-icons:arrow-right-1 ml-8 size-16"></div></div>
          </RouterLink>
        </div>

        <div class="mt-40 h-333 flex justify-between rounded-32 bg-white p-32" v-if="data[4]">
          <div class="mt-54 w-276">
            <h3 class="line-clamp-2 text-36 text-#0a0b5c font-medium leading-120%">{{ data[4].columnName.slice(0, 4) }} <br> {{ data[4].columnName.slice(4) }}</h3>
            <p class="line-clamp-4 mt-16 w-276 text-17 text-#263238 font-normal leading-normal">{{ data[4].columnDesc }}</p>
          </div>
          <div>
            <img src="@/home/assets/home/4/column4.png" class="mt-18 h-156 w-225 object-cover">
            <RouterLink :to="`/column/detail/${data[4].columnId}`" target="_blank" class="group block">
              <button class="mt-45 h-50 w-220 border-1.5 border-#0a0b5c rounded-160 border-solid bg-white text-16 text-#0a0b5c font-normal">查看专栏</button>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-40 h-166 flex-y-center justify-between rounded-102 bg-white pb-50 pl-50 pr-32 pt-40" v-if="data[5]">
      <div class="flex items-end">
        <img src="@/home/assets/home/4/column5.png" class="size-68 bg-cover">
        <div class="ml-18 w-645">
          <h3 class="line-clamp-1 text-36 text-#0a0b5c font-medium leading-120%">{{ data[5].columnName }}</h3>
          <p class="line-clamp-1 mt-8 text-17 text-#263238 font-normal leading-normal">{{ data[5].columnDesc }}</p>
        </div>
      </div>
      <RouterLink :to="`/column/detail/${data[5].columnId}`" target="_blank" class="group ml-88 block cursor-pointer">
        <button class="h-50 w-220 border-1.5 border-#0a0b5c rounded-160 border-solid bg-white text-16 text-#0a0b5c font-normal">查看专栏</button>
      </RouterLink>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
